import { compose, path, pathEq, find, curry } from 'ramda';

import {
  selectFields,
  selectFieldsByKey,
} from '../../lib/contentful/selectors';
import { selectPage, selectPreviousPage } from '../location/selectors';

export const selectEntries = path(['content', 'entries']);

export const selectEntry = curry((entryId, state) =>
  compose(find(pathEq(['sys', 'id'], entryId)), selectEntries)(state)
);

export const selectContent = curry((entryId, state) =>
  compose(selectFields, selectEntry(entryId))(state)
);

export const selectDefaultTemplate = path(['content', 'template']);

export const selectPreviousContent = (state) => {
  const { entryId } = selectPreviousPage(state) || {};
  if (!entryId) return;

  return selectContent(state, entryId);
};

export const selectCurrentPage = (state) => {
  const { entryId } = selectPage(state);
  if (!entryId) return;

  return selectContent(entryId, state);
};

export const selectCurrentTemplate = (state) =>
  compose(selectFieldsByKey('template'), selectCurrentPage)(state) ||
  compose(selectFields, selectDefaultTemplate)(state);

export const selectInvite = (state) => state.content?.invite;

export const selectRoutinesCampaign = (state) =>
  state.content?.routinesCampaign;
